if($('footer#footer').length){
    $('footer#footer').after($('.footer-bottom'))
}